import React from 'react';

type TypeProps = {
  color: string;
};

const Icon = ({ color }: TypeProps) => {
  return (
    <svg
      id="Pointers"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 179.74 175.66"
      width={30}
      height={30}
      style={{
        top: '-8px',
        left: '-8px',
      }}
    >
      <defs></defs>
      <g style={{ opacity: 0.2 }}>
        <circle style={{ fill: '#ff571e' }} cx="93.96" cy="89.87" r="47.12" />
      </g>
      <g style={{ opacity: 0.3 }}>
        <circle style={{ fill: '#ff571e' }} cx="93.96" cy="89.87" r="35.7" />
      </g>
      <circle style={{ fill: '#ff571e' }} cx="93.96" cy="89.87" r="23.36" />
    </svg>
  );
};

export default Icon;